import axios from '../../../../../redux/my-axios';

export const PRODUCTS_URL = '/products';

// READ
export function findProducts(queryParams) {
  //console.log(queryParams);
  return axios.post(PRODUCTS_URL, queryParams, { headers: { action: 'find' } });
}

export function getProduct(productCode) {
  return axios.post(PRODUCTS_URL, productCode, { headers: { action: 'get' } });
}

export function createProduct(productForCreate) {
  return axios.post(PRODUCTS_URL, productForCreate, {
    headers: { action: 'post' },
  });
}

export function updateProduct(productForView) {
  return axios.post(PRODUCTS_URL, productForView, {
    headers: { action: 'put' },
  });
}

export function deleteProduct(productCode) {
  return axios.post(PRODUCTS_URL, productCode, {
    headers: { action: 'delete' },
  });
}
